<template>
	<header id="theme-header" class="theme-header">
		<transition :style="{ '--totalStagger': 1 }" name="slide-in" appear>
			<div ref="header" :style="'--indexStagger: 0'" class="main-header padding-bottom-lg padding-top-lg">
				<div class="inner container__extra">
					<HNKLogo />
					<div class="menu-holder">
						<WpNavi class="main-menu" location="main-menu" />
						<div v-if="getOptions.dark_button || getOptions.light_button" class="buttons-header">
							<ColorLink
								v-if="getOptions.light_button && getOptions.light_button.url"
								:icon="false"
								uppercase
								small
								:link="getOptions.light_button"
								color="white"
								outlined
							/>
							<ColorLink
								v-if="getOptions.dark_button && getOptions.dark_button.url"
								:icon="false"
								uppercase
								small
								:link="getOptions.dark_button"
								color="black"
							/>
						</div>
						<button
							@click="toggleMenu"
							class="menu-button plain-button"
							aria-label="Meny"
							v-html="menu"
						></button>
						<button
							@click="toggleSearch"
							class="search-button plain-button"
							aria-label="Søke"
							v-html="search"
						></button>
					</div>
				</div>
			</div>
		</transition>
		<div class="scrolled-header" :class="{ 'animate-in': showSubHeader }" ref="scrolledHeader">
			<div class="inner-scrolled container__extra">
				<HNKLogo :full="false" />
				<div class="side-action">
					<button
						@click="toggleSearch"
						class="search-button plain-button"
						aria-label="Søke"
						v-html="search"
					></button>
					<button
						@click="toggleMenu"
						class="menu-button plain-button"
						aria-label="Meny"
						v-html="menu"
					></button>
				</div>
			</div>
		</div>
		<transition name="opacity">
			<div @click="hideAnyOpenMenu" v-show="mainNaviIsOpen || searchModalOpen" class="page-overlay"></div>
		</transition>
		<SideMenu v-show="mainNaviIsOpen" />
		<SearchSide v-show="searchModalOpen" />
	</header>
</template>

<script>
import _debounce from 'lodash.debounce'

const WpNavi = () => import('@/components/elements/WpNavi')
const SideMenu = () => import('@/components/elements/SideMenu')
const SearchSide = () => import('@/components/elements/SearchSide')
import ColorLink from '@/components/elements/ColorLink'
import HNKLogo from '@/components/elements/HNKLogo'
import { search, menu } from '@/components/../icons'

import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'theme-header',
	data() {
		return {
			search: search('var(--dark)'),
			menu: menu('var(--dark)'),
			lastScrollTop: 0,
			delta: 50,
			navbarHeight: 0,
			showSubHeader: false,
			firstTriggerMenu: false,
			firstTriggerSearch: false,
			window: {
				width: 0,
				height: 0,
			},
		}
	},
	components: {
		WpNavi,
		ColorLink,
		HNKLogo,
		SideMenu,
		SearchSide,
	},
	watch: {},
	created() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	mounted() {
		window.addEventListener('scroll', this.wathScroll, { passive: true })
		if (this.$refs.header) {
			const headerRect = this.$refs.header.getBoundingClientRect()
			this.navbarHeight = headerRect
			this.wathScroll()
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.wathScroll)
		window.removeEventListener('resize', this.handleResize)
	},
	computed: {
		...mapGetters(['currentPage', 'getOptions', 'mainNaviIsOpen', 'searchModalOpen']),
	},
	methods: {
		...mapMutations(['SEARCH_MODAL_CHANGE_STATE', 'MENU_OPEN_CHANGE_STATE']),
		handleResize: _debounce(function () {
			this.window.width = window.innerWidth
			this.window.height = window.innerHeight
		}, 250),
		hideAnyOpenMenu() {
			if (this.mainNaviIsOpen) {
				this.MENU_OPEN_CHANGE_STATE()
			}
			if (this.searchModalOpen) {
				this.SEARCH_MODAL_CHANGE_STATE()
			}
		},
		toggleMenu() {
			this.MENU_OPEN_CHANGE_STATE()
		},
		toggleSearch() {
			this.SEARCH_MODAL_CHANGE_STATE()
		},
		wathScroll: function () {
			const st = window.pageYOffset
			const VM = this
			let multiplier = 2.2
			let triggerHeight = this.navbarHeight.height

			if (Math.abs(VM.lastScrollTop - st) <= VM.delta) return

			if (this.window.width < 767) {
				let hwat = document.getElementsByClassName('head_watch ')
				let featuredImage = document.getElementsByClassName('image-post')
				if (hwat && hwat[0]) {
					triggerHeight = hwat[0].getBoundingClientRect().height
					multiplier = 1.3
				}
				if (featuredImage && featuredImage[0]) {
					triggerHeight = triggerHeight + featuredImage[0].getBoundingClientRect().height
					multiplier = 1.2
				}
			}

			if (triggerHeight * multiplier < st) {
				if (!this.showSubHeader) {
					this.showSubHeader = true
				}
			} else if (this.showSubHeader) {
				this.showSubHeader = false
			}
			VM.lastScrollTop = st
		},
	},
}
</script>

<style lang="scss">
@import './../assets/vars.scss';
@import './../assets/mixins.scss';
@import './../assets/extends.scss';
.page-overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 9998;
	background-color: rgba(#000, 0.3);
	cursor: pointer;
}
.theme-header {
	position: relative;
	.scrolled-header {
		position: fixed;
		top: 50px;
		pointer-events: none;
		touch-action: none;
		width: 100%;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		z-index: 999;
		padding-left: 50px;
		padding-right: 50px;
		@include mquery($phone) {
			padding-left: 31px;
			padding-right: 31px;
			top: 20px;
		}
		.side-action {
			display: flex;
			flex-direction: column-reverse;
			.menu-button {
				margin-bottom: 40px;
			}
			@include mquery($phone) {
				position: absolute;
				right: 13px;
				top: 91px;
				.menu-button {
					margin-bottom: 0px;
					margin-top: 25px;
					svg {
						width: 17px * 0.8;
						height: 13px * 0.8;
					}
				}
				.search-button {
					order: 1;
					svg {
						width: 17px * 0.8;
						height: 18px * 0.8;
					}
				}
			}
		}
		.inner-scrolled {
			display: flex;
			justify-content: space-between;
			width: 100%;
			margin-left: -66px;
			margin-right: -66px;
			@include mquery($tablet) {
				width: calc(100% + 132px);
				margin-left: -20px;
				margin-right: -20px;
			}
			@include mquery($phone) {
			}
		}

		// animate buttons
		.search-button,
		.menu-button {
			opacity: 0;
			visibility: hidden;
			transform: translateY(-25px);
			transition: all 0.15s ease-in-out;
			will-change: opacity, visibility;
		}
		.menu-button {
			@include mquery($phone) {
				transition-delay: 0.1s;
			}
		}
		.search-button {
			transition-delay: 0.1s;
			@include mquery($phone) {
				transition-delay: 0s;
			}
		}

		//Animate logo
		.full-logo-container {
			opacity: 0;
			visibility: hidden;
			will-change: opacity, visibility;
			transition: all 0.15s ease-in-out;
			transition-delay: 0s;
			@include mquery($phone) {
				position: absolute;
				right: 20px;
			}
			// .middle, .letter_n path, .letter_k path, .line_left path, .line_right{

			// }

			.line_left path,
			.line_right {
				transition: all 0.1s ease-in-out;
				transition-delay: 0.1s;
			}
			.line_right {
				transform: scaleY(0) translate(12.451691px, 40.374386px);
				transform-origin: center 60px;
			}
			.line_left path {
				transform: scaleY(0);
				transform-origin: top;
			}

			.middle {
				transform: scaleY(0) translate(6.7308655px, 24.670393px);
				transform-origin: center;
				transition: all 0.1s ease-in-out;
				transition-delay: 0s;
			}

			.letter_n path,
			.letter_k path {
				transition: all 0.15s ease-in-out;
				transition-delay: 0.15s;
			}
			.letter_n path {
				transform: translateY(30px);
			}
			.letter_k path {
				transform: translateY(-30px);
			}
		}
		&.animate-in {
			// animate buttons
			.full-logo-container {
				opacity: 1;
				visibility: visible;
				transition-delay: 0s;
			}
			.search-button,
			.menu-button {
				transform: translateY(0);
				opacity: 1;
				visibility: visible;
				transition: all 0.3s ease-in-out;
			}
			.search-button {
				transition-delay: 0.1s;
				@include mquery($phone) {
					transition-delay: 0s;
				}
			}

			//Animate logo
			.middle {
				transform: scaleY(1) translate(6.7308655px, 24.670393px);
				transition: all 0.2s ease-in-out;
				transition-delay: 0.2s;
			}

			.line_left path,
			.line_right {
				transition: all 0.2s ease-in-out;
				transition-delay: 0.3s;
			}
			.line_right {
				transform: scaleY(1) translate(12.451691px, 40.374386px);
			}
			.line_left path {
				transform: scaleY(1);
			}

			.letter_n path,
			.letter_k path {
				transition: all 0.3s ease-in-out;
				transition-delay: 0s;
			}
			.letter_n path {
				transform: translateY(0px);
			}
			.letter_k path {
				transform: translateY(0px);
			}
		}
	}

	.full-logo-container,
	.plain-button {
		pointer-events: all;
		touch-action: initial;
	}
	.main-header {
		display: flex;
		margin: 0 auto;
		display: flex;
		justify-content: center;
	}
	.plain-button {
		margin-left: 40px;
		cursor: pointer;
		border: none;
		box-shadow: none;
		background: transparent;
		@include mquery(1200px) {
			margin-left: 20px;
		}
	}
	.inner {
		display: flex;
		align-items: flex-end;
		width: calc(100% + 132px);
		margin-left: -66px;
		margin-right: -66px;
		@include mquery($tablet) {
			margin-left: -57px;
			margin-right: -57px;
		}
		@include mquery($phone) {
			width: calc(100% + 65px);
			margin-left: 0px;
			margin-right: -40px;
		}

		.menu-button {
			display: none;
			@include mquery($tablet) {
				display: block;
			}
		}
		.menu-holder {
			margin-left: auto;
			display: flex;
			align-items: center;
			.main-menu {
				@include mquery($tablet) {
					display: none;
				}
			}

			.wp-navi-links {
				padding: 0;
				margin: 0;
				list-style: none;
				display: flex;
			}
			li {
				margin-right: 40px;
				&:last-child {
					margin-right: 0;
				}
				@include mquery(1200px) {
					margin-right: 20px;
					&:last-child {
						margin-right: 0;
					}
				}
			}
			a {
				display: inline-block;
				text-decoration: none;
				@include fluid-type($smallResText, $wideResText, 16px, 20px);
			}
		}
	}
	.buttons-header {
		margin-left: 40px;
		@include mquery(1200px) {
			margin-left: 20px;
		}
		@include mquery($phone) {
			display: none;
		}

		.fill-button {
			margin-right: 20px;
			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style>
